<template>
  <div class="dashboard-block">
    <profile-talent-stats :stats="user.talent_stats" v-if="$userIsAdmin"/>

    <h2>Public Details</h2>
    <profile-talent-tagline/>
    <profile-talent-social-media v-if="!$hideSocialMediaReferences"/>

    <div class="margin-20"></div>

    <h3>Visibility</h3>

    <p>Control where you will show up in searches and the services and packages you offer through {{ clientName }}</p>

    <ul class="item-detail item-detail-simple">
      <li v-for="link in links" :key="link.name" @click="() => { trackSectionClick(link.name) }">
        <router-link :to="link.route">
          <div class="row">
            <div class="col-xs-8">
              <h3 class="has-sub">{{ link.heading }}</h3>
              <p class="sub-text">{{ link.description }}</p>
            </div>
            <div class="col-xs-4">
              <div class="actions pull-right">
                <span class="btn btn-info">
                  <i class="fa fa-pencil"></i>
                </span>
              </div>
            </div>
          </div>
        </router-link>
      </li>
    </ul>
    <profile-talent-vlast-pdf-download v-if="$vlastMode && clientName === 'NRL' && $userIsAdmin" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ProfileTalentTagline from './ProfileTalentTagline'
import ProfileTalentSocialMedia from './ProfileTalentSocialMedia'
import ProfileTalentStats from './ProfileTalentStats'
import ProfileTalentVlastPdfDownload from './ProfileTalentVlastPdfDownload'
import { OpportunityTracker } from 'mixins/analytics'

export default {
  mixins: [OpportunityTracker],
  components: {
    ProfileTalentVlastPdfDownload,
    ProfileTalentStats,
    ProfileTalentTagline,
    ProfileTalentSocialMedia
  },

  methods: {
    trackSectionClick (linkName) {
      const sectionNames = {
        description: this.analytics.V2.ValidatedAccountSectionName.DESCRIPTION,
        career: this.analytics.V2.ValidatedAccountSectionName.CAREER,
        interests: this.analytics.V2.ValidatedAccountSectionName.INTERESTS,
        locations: this.analytics.V2.ValidatedAccountSectionName.LOCATIONS,
        industries: this.analytics.V2.ValidatedAccountSectionName.INDUSTRIES,
        'known-for': this.analytics.V2.ValidatedAccountSectionName.KNOWN_FOR,
        'charity-and-sponsor': this.analytics.V2.ValidatedAccountSectionName.CHARITY_AND_SPONSORSHIP,
        themes: this.analytics.V2.ValidatedAccountSectionName.SPECIALIST_TOPICS,
        image: this.analytics.V2.ValidatedAccountSectionName.IMAGE,
        availability: this.analytics.V2.ValidatedAccountSectionName.AVAILABILITY,
        endorsements: this.analytics.V2.ValidatedAccountSectionName.ENDORSEMENTS,
        packages: this.analytics.V2.ValidatedAccountSectionName.PACKAGES
      }
      this.trackEvent(this.analytics.V2.AccountSectionClickEvent, { sectionName: sectionNames[linkName] })
    }
  },

  computed: {
    ...mapState('user', ['user']),

    links () {
      const params = { id: this.user.id }
      const links = [
        { name: 'description', route: { name: `${this.$route.name}.description`, params }, heading: 'Profile description', description: 'Long text description visible at the top of your profile page.', show: true },
        { name: 'career', route: { name: `${this.$route.name}.career`, params }, heading: 'Career', description: 'Let clients know your past and present career(s).', show: this.$hasTagNodes },
        { name: 'interests', route: { name: `${this.$route.name}.interests`, params }, heading: 'Interests and Hobbies', description: 'Choose your interests and hobbies to increase your chance of getting booked.', show: this.$hasInterestCategories || this.$hasPersonalInterests },
        { name: 'locations', route: { name: `${this.$route.name}.locations`, params }, heading: 'Where I am based', description: 'Long text description visible at the top of your profile page.', show: true },
        { name: 'industries', route: { name: `${this.$route.name}.industries`, params }, heading: 'Industry Details', description: 'Industries that you are involved in.', show: !this.$hasTagNodes },
        { name: 'known-for', route: { name: `${this.$route.name}.known-for`, params }, heading: 'What I am known for', description: 'Sports you have played and clubs you have played for along with other tags.', show: !this.$hasTagNodes },
        { name: 'charity-and-sponsor', route: { name: `${this.$route.name}.charity-and-sponsor`, params }, heading: this.$t('Charities and Sponsors'), description: this.$t('Let people know who your sponsors are and which charities you support.'), show: true },
        { name: 'themes', route: { name: `${this.$route.name}.themes`, params }, heading: this.$t('Specialist Topics'), description: `Set ${this.$t('Specialist Topics').toLowerCase()} tags.`, show: (this.$userIsAdmin || this.$userIsIntern) || (this.$userIsManager && this.$vlastMode) },
        { name: 'image', route: { name: `${this.$route.name}.image`, params }, heading: 'Profile Image & Marketing Photos', description: 'Upload a profile image and marketing photos to be used throughout the site', show: true },
        { name: 'availability', route: { name: `${this.$route.name}.availability`, params }, heading: 'Manage Event Types', description: 'Choose what type of event types you are available for. Eg: Meet and greet or Corporate event.', show: true },
        { name: 'endorsements', route: { name: `${this.$route.name}.endorsements`, params }, heading: 'Endorsements', description: 'Create and edit endorsements which are visible on your profile.', show: (this.$userIsAdmin || this.$userIsIntern) && !this.$isNflClub },
        { name: 'packages', route: { name: `${this.$route.name}.packages`, params }, heading: 'Manage Packages', description: 'Choose what type of packages you are available for. Eg: Video shoutouts or virtual appearances.', show: !this.$vlastMode }
      ]
      return links.filter(link => link.show)
    }
  }
}
</script>
